import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Container, Row, Button, Form, InputGroup, Spinner, ButtonGroup, Offcanvas } from "react-bootstrap";
import { zeroPad } from "react-countdown";
import "../../assets/css/component.css";
import CarouselLayout from "../../containers/Layouts/CarouselLayout/CarouselLayout";
import CarouselMultipleLayout from "../../containers/Layouts/CarouselLayout/CarouselMultipleLayout";
import CardUnit from "../../components/CardUnit/CardUnit";
import ConnectionLatency from "../../components/ConnectionLatency/ConnectionLatency";
import Time from "../../assets/icons/Time";
import Location from "../../assets/icons/Location";
import Coupon from "../../assets/icons/Coupon";
import imageCar from "../../assets/images/category-car.png";
import { useHistory, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { showBidErrorToast } from "../../utils/bidToast";
import { format } from "date-fns";
import CurrencyInput from "react-currency-input-field";
import ArtworkPending from "./ArtworkPending";
import PageNotFound from "../Errors/PageNotFound";
import { actionsLiveAuction } from "../../redux/liveAuction.slice";
import { userSelector } from "../../redux/auth.slice";
import { useDispatch, useSelector } from "react-redux";
import ResultLelang from "../../components/Modals/ResultLelang";
import SpecialNIPL from "../../assets/icons/SpecialNIPL";
import Warning from "../../assets/icons/Warning";
import LockOff from "../../assets/icons/lock_off";
import LockOn from "../../assets/icons/lock_on";
import { isDate } from "../../utils/string";
import moment from "moment";
import SubstractIcon from "../../assets/icons/SubsctractIcon";
import PlusIcon from "../../assets/icons/PlusIcon";
import KonfirmasiBatalBid from "../../components/Modals/KonfirmasiBatalBid";
import "moment/locale/id";
import OnlineAuctionSkeleton from "../../components/Skeleton/OnlineAuctionSkeleton";
import * as io from "socket.io-client";
import { TimerIcon } from "../../assets/icons/AuctionIcons";
import {
  textDark,
  textWhite,
  danger,
  socketConnected,
  socketReconnecting,
  socketDisconnected,
  socketError,
  socketUnknown,
} from "../../config/colors";
import { formatSimpleDateRange } from "../../helpers/dateRangeFormatter";
import NoImage from "../../assets/images/NoImage.jpg";

moment.locale("id");

const defaultImage = NoImage;
const initialBid = {
  buyer: {},
  offer_price: 0,
  type: "-",
};

const initialDataModal = {
  lot_number: "",
  data_unit: {},
};

// Lazy Load Component for Lot Cards
const LazyLotCard = ({ item, auction, id, push }) => {
  const cardRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const currentRef = cardRef.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !shouldRender) {
            setShouldRender(true);
          }
        });
      },
      {
        root: null,
        rootMargin: "200px", // Load 200px before entering viewport
        threshold: 0.01,
      }
    );

    observer.observe(currentRef);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [shouldRender]);

  const unitDetail = useMemo(() => {
    if (!shouldRender) return null;
    
    const visibleInfos = (item?.unit_informations || []).filter(info => info.is_visible !== 0);
    const year = visibleInfos.find((unit_information) => unit_information.label === "Tahun");
    const odometer = visibleInfos.find((unit_information) => unit_information.label === "Odometer");
    const transmisi = visibleInfos.find((unit_information) => unit_information.label === "Transmisi");
    const fuel = visibleInfos.find((unit_information) => unit_information.label === "Bahan Bakar");
    const validityPeriod = item?.unit_documents?.find((unit_document) => unit_document.label === "STNK");

    return {
      police_number: item?.police_number,
      year: year?.value,
      odometer: odometer?.value,
      transmisi: transmisi?.value,
      fuel: fuel?.value,
      validityPeriod: validityPeriod?.additional_value,
    };
  }, [shouldRender, item]);

  return (
    <div
      ref={cardRef}
      style={{ padding: "0 8px", cursor: "pointer" }}
      onClick={() => {
        if (shouldRender) {
          push(`/close-bid-auction/${id}/${item?.id}`);
          window.location.reload();
        }
      }}
    >
      {shouldRender ? (
        <CardUnit
          timeLocation={true}
          lot_number={item?.lot_number || "-"}
          price={item?.base_price}
          tags={item?.tags || []}
          nama={item?.unit_name}
          location={item?.auction?.location_name}
          auction={auction}
          pictures={item?.pictures}
          grade={item?.unit_inspection?.grade}
          unitType={item?.unit_type?.name}
          unitDetail={unitDetail}
        />
      ) : (
        <div
          style={{
            minHeight: "350px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner animation="border" size="sm" variant="secondary" />
        </div>
      )}
    </div>
  );
};

export default function CloseBidAuction() {
  const thisUser = useSelector(userSelector);
  const [SpecialNIPLToggle, setSpecialNIPLToggle] = useState({
    remaining_nipls: 0,
    used_nipls_this_stock_unit: 0,
    is_special_nipl: "false",
    number_of_nipl: 0,
  });

  const { id, unitId } = useParams();
  const { push } = useHistory();
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState("LOADING");
  const [key, setKey] = useState(1);
  const [color, setColor] = useState("success");
  const [colorCancel, setColorCancel] = useState("danger");
  const [dataModal, setDataModal] = useState({ ...initialDataModal });

  // status
  const [disableBid, setDisabledBid] = useState("off");
  const [blockBid, setBlockBid] = useState("off");
  const [isProcess, setIsProcess] = useState("off");
  const [isCancelProcess, setIsCancelProcess] = useState("off");
  const [liveAuction, setLiveAuction] = useState("COMING");
  const [FirstBid, setFirstBid] = useState(false);
  const [isSelectingWinner, setIsSelectingWinner] = useState(false);
  const shouldEmitTotalNipl = useRef(true);

  // list
  const [data, setData] = useState({});
  const [auction, setAuction] = useState({});
  const [modalCancel, setModalCancel] = useState(false);
  const [images, setImages] = useState([]);
  const [nextLots, setNextLots] = useState([]);
  const [allNextLots, setAllNextLots] = useState([]); // Store all lots
  const [showAllLots, setShowAllLots] = useState(false); // Toggle for showing all lots
  const [biddingList, setBiddingList] = useState([]);

  // bid
  const [offer, setOffer] = useState(0);
  const [error, setError] = useState("");
  const [highestBid, setHighestBid] = useState({ ...initialBid });
  const [multipleBid, setMultipleBid] = useState(0);
  const [counter, setCounter] = useState(null);

  // loader
  const [unitLoader, setUnitLoader] = useState(false);
  const [nextUnitLoader, setNextUnitLoader] = useState(false);
  const [bidLoader, setBidLoader] = useState(false);
  const [socketStatus, setSocketStatus] = useState("connecting");
  // Latency socket ke server (ms) dari ping/pong socket.io, untuk indikator koneksi.
  const [latencyMs, setLatencyMs] = useState(null);
  useEffect(() => {
    if (socketStatus !== "connected") setLatencyMs(null);
  }, [socketStatus]);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [maxReconnectReached, setMaxReconnectReached] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const prevUnitId = useRef();
  const reconnectCountRef = useRef(0);
  const stableConnectionTimerRef = useRef(null);
  const joinRoomTimeoutRef = useRef(null);

  const URL = process.env.REACT_APP_SOCKET;
  const token = localStorage.getItem("token");
  const AccessToken = `Bearer ${token}`;
  const MAX_RECONNECT_ATTEMPTS = 10;
  const STABLE_CONNECTION_DELAY = 5000;

  const socketRef = useRef(null);
  const auctionSocketRoom = `user_auction:${id}`;

  if (!socketRef.current) {
    socketRef.current = io(URL, {
      query: { token: AccessToken },
      transports: ["websocket"],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
      reconnectionDelay: 2000,
      timeout: 10000,
      forceNew: false,
    });
  }

  const handleJoinAuction = useCallback(() => {
    console.log("✅ Connected to server");
    socketRef.current.emit("JoinCloseBid", {
      user_room: auctionSocketRoom,
    });
  }, [auctionSocketRoom]);

  const toastError = useCallback((message) => showBidErrorToast(message), []);

  // Consolidated UI components
  const UnitInformation = useCallback(({ informations, documents }) => {
    const allInfo = [
      ...(informations?.filter((el) => el.value !== "") || []),
      ...(documents?.filter((el) => el.value !== "") || []),
    ];

    return (
      <div
        className="unit-information-wrapper"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gap: "8px",
        }}
      >
        {allInfo.length > 0
          ? allInfo.map(({ label, value }, idx) => (
              <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                <span className="title">{label}</span>
                <span className="value">
                  {isDate(value) ? moment(value).format("DD MMM YYYY") : value !== "null" && value ? value : "-"}
                </span>
              </div>
            ))
          : ""}
      </div>
    );
  }, []);

  const processBidderData = useCallback((bidders) => {
    if (!bidders || bidders.length === 0) return { highestBid: null, biddingList: [] };

    const processedBidders = bidders
      .slice()
      .reverse()
      .map((bidder) => ({
        ...bidder,
        type: "Close Bid Bidder",
        offer_price: parseInt(bidder.offer) || 0,
        buyer_user_id: bidder.user_id || null,
        created_at: bidder.created_at || null,
      }));

    const highestBid = {
      email: processedBidders[0]?.email || "",
      buyer_user_id: processedBidders[0]?.buyer_user_id || null,
      offer_price: parseInt(processedBidders[0]?.offer_price) || 0,
      type: processedBidders[0]?.type || "Harga Dasar",
      created_at: processedBidders[0]?.created_at,
    };

    const biddingList = processedBidders.filter((_, idx) => idx !== 0);

    return { highestBid, biddingList };
  }, []);

  const findUnitById = (list, id) => {
    if (!Array.isArray(list)) return null;
    const target = Number.isNaN(Number(id)) ? String(id) : Number(id);
    return (
      list.find((u) => {
        if (u == null) return false;
        if (typeof u.id === "number" && typeof target === "number") return u.id === target;
        return String(u.id) === String(target);
      }) ?? null
    );
  };

  // Main Socket Handler
  const handleSocketAuction = useCallback(
    (auctionData) => {
      const currentAuction = auctionData?.auction;
      if (currentAuction?.status === "CLOSED") {
        setIsOpen(false);
      }

      setAuction({
        ...currentAuction,
        nipls_count: auctionData?.auction_nipls?.length || 0,
      });
      setLiveAuction(currentAuction?.status);

      if (
        currentAuction?.status === "STARTED" &&
        (auctionData?.seconds_left_before === 0 || auctionData?.seconds_left_before === null)
      ) {
        setIsSelectingWinner(true);
      } else {
        setIsSelectingWinner(false);
      }

      // Dispatch lot data to Redux for header dropdown
      // Close Bid uses current_unit array, fallback to all_lot for compatibility
      const lotData = auctionData?.current_unit || auctionData?.all_lot;
      if (lotData && Array.isArray(lotData)) {
        dispatch(actionsLiveAuction.setAllLots({ allLots: lotData }));
      }

      if (auctionData?.current_unit !== null) {
        let unitNow = findUnitById(auctionData?.current_unit, unitId);

        // Normalize data structure untuk kompatibilitas
        const normalizedUnit = {
          ...unitNow,
          // Map stock_only_value_informations ke stock_informations jika tidak ada
          stock_informations: unitNow?.stock_informations || unitNow?.stock_only_value_informations || [],
          // Map stock_document_only_value ke stock_documents jika tidak ada
          stock_documents: unitNow?.stock_documents || unitNow?.stock_document_only_value || [],
        };

        let bidders = normalizedUnit?.bidders;

        setData(normalizedUnit);
        // Get all lots for "Lot Lainnya" - use current_unit for Close Bid, fallback to all_lot
        // Filter out the currently displayed lot
        const lotsForNextLot = (auctionData?.current_unit || auctionData?.all_lot || []).filter(
          (lot) => String(lot.id) !== String(unitId)
        );
        setAllNextLots(lotsForNextLot); // Store all lots
        setNextLots(lotsForNextLot.slice(0, 4)); // Show only first 4 by default
        setImages(normalizedUnit?.pictures);

        const { highestBid: processedHighestBid, biddingList: processedBiddingList } = processBidderData(bidders);

        const newHighestBid = processedHighestBid || {
          email: "base_price",
          type: "Harga Dasar",
          offer_price: unitNow?.base_price || 0,
        };

        setHighestBid(newHighestBid);
        setBiddingList(processedBiddingList);
        setFirstBid(bidders && bidders.length > 0);
        setMultipleBid(currentAuction?.unit_type?.multiple_bid || 0);

        let nextOffer = 0;
        const multipleBidAmount = parseInt(currentAuction?.unit_type?.multiple_bid) || 0;
        const basePrice = parseInt(unitNow?.base_price) || 0;

        // Check if there are actual bids
        const hasActualBids = bidders && bidders.length > 0 && processedHighestBid;

        if (hasActualBids) {
          // If there are real bids, add multiple_bid to highest bid
          const highestOfferPrice = parseInt(processedHighestBid.offer_price) || 0;
          nextOffer = highestOfferPrice + multipleBidAmount;
        } else {
          // If no bids yet, use base price without adding multiple_bid
          nextOffer = basePrice;
        }
        setOffer(nextOffer);

        setBlockBid("off");
      }

      setKey((prev) => prev + 1);
      setCounter(auctionData?.seconds_left_before || null);

      setUnitLoader(false);
      setBidLoader(false);
      setNextUnitLoader(false);
    },
    [unitId, processBidderData, dispatch]
  );

  // Handler
  const changeOffer = (val) => {
    const value = parseInt(val);
    let newError = "";

    if (!val || isNaN(value) || value <= 0) {
      newError = "Penawaran tidak boleh kosong atau tidak valid";
    } else if (value < highestBid.offer_price) {
      newError = `Penawaran harus lebih besar dari penawaran saat ini`;
    } else if (multipleBid > 0 && value % multipleBid !== 0) {
      newError = `Penawaran harus kelipatan ${multipleBid.toLocaleString()}`;
    } else {
      newError = "";
    }

    setError(newError);
    setOffer(value || 0);
  };

  const bidHandler = () => {
    if (disableBid === "off") {
      setDisabledBid("on");
    } else {
      setDisabledBid("off");
    }
  };

  const postBid = async () => {
    setIsProcess("on");

    if (error.length > 0) {
      toastError(error);
      setIsProcess("off");
    } else {
      socketRef.current.emit("BidCloseBid", {
        user_room: auctionSocketRoom,
        offer: offer,
        unit_id: Number(unitId),
      });

      if (shouldEmitTotalNipl.current && id) {
        emitTotalNipl(parseInt(id, 10));
        shouldEmitTotalNipl.current = false;
      }
    }
    setIsProcess("off");
  };

  const cancelBid = async () => {
    setIsCancelProcess("on");
    if (error.length > 0) {
      toastError(error);
      setIsCancelProcess("off");
    } else {
      socketRef.current.emit("CancelBidCloseBid", {
        user_room: auctionSocketRoom,
        unit_id: Number(unitId),
      });
    }
    setIsCancelProcess("off");
    setModalCancel(false);
  };

  const secondsToTime = (secs) => {
    if (!secs || secs <= 0) return "00:00:00";

    const days = Math.floor(secs / (24 * 60 * 60));
    const remainingAfterDays = secs % (24 * 60 * 60);

    const hours = Math.floor(remainingAfterDays / (60 * 60));
    const remainingAfterHours = remainingAfterDays % (60 * 60);

    const minutes = Math.floor(remainingAfterHours / 60);
    const seconds = Math.ceil(remainingAfterHours % 60);

    if (days > 0) {
      return `${days}h ${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
    }

    return `${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
  };

  const emitTotalNipl = useCallback(
    (auctionId) => {
      if (socketRef.current && auctionId) {
        socketRef.current.emit("TotalNipl", {
          auction_id: auctionId,
          unit_id: Number(unitId),
        });
      }
    },
    [unitId]
  );

  // Socket Status Helpers
  const getSocketStatusColor = () => {
    switch (socketStatus) {
      case "connected":
        return socketConnected;
      case "connecting":
        return socketReconnecting;
      case "reconnecting":
        return socketDisconnected;
      case "disconnected":
        return socketError;
      case "failed":
        return socketUnknown;
      default:
        return socketUnknown;
    }
  };

  const getSocketStatusText = () => {
    switch (socketStatus) {
      case "connected":
        return "Terhubung";
      case "connecting":
        return "Menghubungkan...";
      case "reconnecting":
        return `Mencoba ulang... (${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS})`;
      case "disconnected":
        return "Terputus";
      case "failed":
        return maxReconnectReached ? "Koneksi gagal" : "Gagal terhubung";
      default:
        return "Tidak diketahui";
    }
  };

  const handleRefreshPage = () => {
    window.location.reload();
  };

  const handleClickCancelBid = () => setModalCancel(true);

  const handleIncreaseBid = () => {
    if (disableBid === "on") {
      const increment = parseInt(multipleBid) || 0;
      setOffer((prev) => {
        const currentOffer = parseInt(prev) || 0;
        return currentOffer + increment;
      });
    }
  };
  const handleDecreaseBid = () => {
    if (disableBid === "on") {
      const decrement = parseInt(multipleBid) || 0;
      const basePrice = parseInt(data?.base_price) || 0;
      setOffer((prev) => {
        const currentOffer = parseInt(prev) || 0;
        const newOffer = currentOffer - decrement;
        return newOffer >= basePrice ? newOffer : currentOffer;
      });
    }
  };

  // Socket Event Handlers
  const handleSocketEvent = useCallback(
    (eventType, response) => {
      console.log(`📩 ${eventType}:`, response);

      if (eventType !== "TotalNiplResponse" && !response?.data) {
        console.warn(`⚠️ ${eventType}: Invalid response data`);
        return;
      }

      if (eventType !== "TotalNiplResponse") {
        handleSocketAuction(response.data);
      }

      switch (eventType) {
        case "SendBidResponse": {
          let currentUnit = null;

          // Priority 1: Check in current_unit (contains detailed info like bidders)
          if (Array.isArray(response?.data?.current_unit)) {
            currentUnit = response.data.current_unit.find((unit) => String(unit.id) === String(unitId));
            // Fallback to first unit if specific ID not found
            if (!currentUnit && response.data.current_unit.length > 0) {
              currentUnit = response.data.current_unit[0];
            }
          }

          // Priority 2: Check in all_lot if not found in current_unit
          if (!currentUnit && Array.isArray(response?.data?.all_lot)) {
            currentUnit = response.data.all_lot.find((unit) => String(unit.id) === String(unitId));
          }

          const socketBidders = currentUnit?.bidders;

          if (socketBidders?.length > 0) {
            const latestBidder = socketBidders[socketBidders.length - 1];

            const isMe =
              (latestBidder?.user_id && Number(latestBidder.user_id) === Number(thisUser?.id)) ||
              latestBidder?.email === thisUser?.email;

            if (isMe) {
              toast.success("Penawaran telah dikirim", {
                id: "success-message",
                duration: 3000,
              });
            }
          }
          emitTotalNipl(response.data.auction.id);
          setIsProcess("off");
          break;
        }

        case "CancelBidResponse": {
          toast.success("Penawaran telah dibatalkan", {
            id: "success-message",
            duration: 3000,
          });
          emitTotalNipl(response.data.auction.id);
          setIsCancelProcess("off");
          break;
        }

        case "TotalNiplResponse": {
          let niplData = response?.data?.data || response?.data;
          const remaining = niplData.total_nipl;

          if (niplData && niplData.total_nipl !== undefined) {
            setSpecialNIPLToggle((prev) => {
              if (typeof prev === "object" && prev !== null) {
                return {
                  ...prev,
                  remaining_nipls: remaining,
                  used_nipls_this_stock_unit: niplData.in_use || 0,
                };
              }
              return prev;
            });
          }
          break;
        }

        case "JoinAuctionResponse":
        case "PendingResponse":
        case "StartAuctionResponse": {
          if (response.data.auction?.id && response.data.auction?.status === "STARTED") {
            emitTotalNipl(response.data.auction.id);
          }
          break;
        }

        default:
          console.log(`ℹ️ Unhandled event type: ${eventType}`);
          break;
      }
    },
    [thisUser?.email, unitId, handleSocketAuction, emitTotalNipl]
  );

  const handleSocketError = useCallback((err) => {
    console.log("❌ error:", err);
    toast.error(err.message, {
      id: "error-message",
      duration: 3000,
    });
    setIsProcess("off");
    setIsCancelProcess("off");
  }, []);

  // Socket Setup
  useEffect(() => {
    console.log("🟡 Setting up socket listeners...");

    if (!socketRef.current) {
      console.warn("⚠️ Socket ref is null, skipping listener setup");
      return;
    }

    const handleConnect = () => {
      console.log("✅ Connected to server");
      setSocketStatus("connected");
      handleJoinAuction();

      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
      }

      stableConnectionTimerRef.current = setTimeout(() => {
        console.log("🟢 Connection stable, resetting reconnect counter");
        reconnectCountRef.current = 0;
        setReconnectAttempts(0);
        setMaxReconnectReached(false);
      }, STABLE_CONNECTION_DELAY);
    };

    const handleDisconnect = (reason) => {
      console.log("🔌 Disconnected from server:", reason);
      setSocketStatus("disconnected");

      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
        stableConnectionTimerRef.current = null;
      }
    };

    const handleReconnect = (attemptNumber) => {
      console.log(`🔄 Reconnected to server (attempt ${attemptNumber})`);
      setSocketStatus("connected");
      handleJoinAuction();

      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
      }

      stableConnectionTimerRef.current = setTimeout(() => {
        console.log("🟢 Connection stable, resetting reconnect counter");
        reconnectCountRef.current = 0;
        setReconnectAttempts(0);
        setMaxReconnectReached(false);
      }, STABLE_CONNECTION_DELAY);
    };

    const handleReconnectAttempt = (attemptNumber) => {
      reconnectCountRef.current += 1;
      const totalAttempts = reconnectCountRef.current;

      console.log(`🔄 Reconnection attempt ${totalAttempts} of ${MAX_RECONNECT_ATTEMPTS}`);
      setReconnectAttempts(totalAttempts);
      setSocketStatus("reconnecting");

      if (totalAttempts >= MAX_RECONNECT_ATTEMPTS) {
        console.log("💥 Maximum reconnection attempts reached");
        setMaxReconnectReached(true);
        setSocketStatus("failed");
        if (socketRef.current) {
          socketRef.current.disconnect();
        }
      }
    };

    const handleReconnectError = (error) => {
      console.log("❌ Reconnection error:", error);
      setSocketStatus("reconnecting");
    };

    const handleReconnectFailed = () => {
      console.log("💥 Reconnection failed");
      setSocketStatus("failed");
      setMaxReconnectReached(true);
    };

    const handleConnectError = (err) => {
      console.log("❌ Connection error:", err.message);
    };

    const handleJoinAuctionResponse = (response) => handleSocketEvent("JoinAuctionResponse", response);
    const handleStartAuctionResponse = (response) => handleSocketEvent("StartAuctionResponse", response);
    const handleTotalNiplResponse = (response) => handleSocketEvent("TotalNiplResponse", response);
    const handlePendingResponse = (response) => handleSocketEvent("PendingResponse", response);
    const handleSendBidResponse = (response) => handleSocketEvent("SendBidResponse", response);
    const handleCancelBidResponse = (response) => handleSocketEvent("CancelBidResponse", response);

    const handlePong = (latency) => setLatencyMs(latency);
    socketRef.current.on("connect", handleConnect);
    socketRef.current.on("pong", handlePong);
    socketRef.current.on("disconnect", handleDisconnect);
    socketRef.current.on("reconnect", handleReconnect);
    socketRef.current.on("reconnect_attempt", handleReconnectAttempt);
    socketRef.current.on("reconnect_error", handleReconnectError);
    socketRef.current.on("reconnect_failed", handleReconnectFailed);
    socketRef.current.on("connect_error", handleConnectError);

    socketRef.current.on("JoinAuctionResponse", handleJoinAuctionResponse);
    socketRef.current.on("StartAuctionResponse", handleStartAuctionResponse);
    socketRef.current.on("TotalNiplResponse", handleTotalNiplResponse);
    socketRef.current.on("PendingResponse", handlePendingResponse);
    socketRef.current.on("SendBidResponse", handleSendBidResponse);
    socketRef.current.on("CancelBidResponse", handleCancelBidResponse);
    socketRef.current.on("error", handleSocketError);

    if (!socketRef.current.connected) {
      console.log("🔄 Attempting to connect...");
      socketRef.current.connect();
    }

    return () => {
      console.log("🛑 Cleaning up socket listeners...");

      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
        stableConnectionTimerRef.current = null;
      }

      if (socketRef.current) {
        socketRef.current.off("connect", handleConnect);
        socketRef.current.off("pong", handlePong);
        socketRef.current.off("disconnect", handleDisconnect);
        socketRef.current.off("reconnect", handleReconnect);
        socketRef.current.off("reconnect_attempt", handleReconnectAttempt);
        socketRef.current.off("reconnect_error", handleReconnectError);
        socketRef.current.off("reconnect_failed", handleReconnectFailed);
        socketRef.current.off("connect_error", handleConnectError);

        socketRef.current.off("JoinAuctionResponse", handleJoinAuctionResponse);
        socketRef.current.off("StartAuctionResponse", handleStartAuctionResponse);
        socketRef.current.off("TotalNiplResponse", handleTotalNiplResponse);
        socketRef.current.off("PendingResponse", handlePendingResponse);
        socketRef.current.off("SendBidResponse", handleSendBidResponse);
        socketRef.current.off("CancelBidResponse", handleCancelBidResponse);
        socketRef.current.off("error", handleSocketError);
      }
    };
  }, [handleJoinAuction, handleSocketEvent, handleSocketError]);

  useEffect(() => {
    if (socketRef.current && socketRef.current.connected) {
      console.log("🔄 Room changed, rejoining auction...");
      handleJoinAuction();
    }
  }, [id, handleJoinAuction]);

  useEffect(() => {
    return () => {
      console.log("🛑 Component unmounting, disconnecting socket...");
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      // Cleanup join room timeout
      if (joinRoomTimeoutRef.current) {
        clearInterval(joinRoomTimeoutRef.current);
        joinRoomTimeoutRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (prevUnitId.current !== auction.current_stock_unit_id) {
      setUnitLoader(true);
      setBidLoader(true);
      setNextUnitLoader(true);
    }

    prevUnitId.current = auction?.current_stock_unit_id;
  }, [auction]);

  useEffect(() => {
    let timer = null;

    if (counter > 0) {
      timer = setInterval(() => setCounter((prev) => prev - 1), 1000);
      setIsOpen(false);
      setIsSelectingWinner(false);
      
      // Clear join room interval when counter is running
      if (joinRoomTimeoutRef.current) {
        clearInterval(joinRoomTimeoutRef.current);
        joinRoomTimeoutRef.current = null;
      }
    }

    if (counter === 0) {
      dispatch(actionsLiveAuction.setCurrentDataUnit({ unit: data }));
      setDataModal((prev) => ({
        ...prev,
        lot_number: auction?.auction_lane_name || "",
      }));

      if (liveAuction === "STARTED") {
        setIsSelectingWinner(true);
        setResult("LOADING");
        setIsOpen(false);
      } else if (liveAuction !== "CLOSED") {
        setResult("LOADING");
        setIsOpen(true);
        setIsSelectingWinner(false);
      }

      // Join room again every 10 seconds when timer reaches 00 and auction is still STARTED
      if (liveAuction === "STARTED" && socketRef.current && socketRef.current.connected) {
        // Only create interval if it doesn't exist yet
        if (!joinRoomTimeoutRef.current) {
          console.log("🔄 Timer reached 00 and auction STARTED, setting up interval to rejoin auction room every 10 seconds...");
          joinRoomTimeoutRef.current = setInterval(() => {
            console.log("🔄 Rejoining auction room (waiting for CLOSED status)...");
            handleJoinAuction();
          }, 10000);
        }
      } else {
        // Clear interval if auction is no longer STARTED
        if (joinRoomTimeoutRef.current) {
          clearInterval(joinRoomTimeoutRef.current);
          joinRoomTimeoutRef.current = null;
        }
      }
    } else if (counter <= 3) {
      setBlockBid("on");
      setColor("secondary");
      setColorCancel("secondary");
    } else if (counter <= 5) {
      setColor("danger");
      setColorCancel("danger");
    } else if (counter <= 10) {
      setColor("orange");
      setColorCancel("danger");
    } else if (counter <= 15) {
      setColor("warning");
      setColorCancel("danger");
    } else if (counter > 15) {
      setColor("success");
      setColorCancel("danger");
    }

    return () => {
      if (timer) clearInterval(timer);
      // Don't clear joinRoomTimeoutRef here - let it run until auction is CLOSED
    };
  }, [counter, data, auction, liveAuction, dispatch, handleJoinAuction]);

  useEffect(() => {
    localStorage.removeItem(`highBidTA-${id}-${unitId}`);
    localStorage.removeItem(`listBidderTA-${id}-${unitId}`);
  }, [unitId, id]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && socketRef.current && socketRef.current.connected) {
        console.log("👁️ Page became visible, rejoining auction...");
        handleJoinAuction();
      }
    };

    const handleFocus = () => {
      if (socketRef.current && socketRef.current.connected) {
        console.log("🎯 Window focused, rejoining auction...");
        handleJoinAuction();
      }
    };

    const handleOnline = () => {
      console.log("🌐 Network back online, reconnecting...");
      if (socketRef.current && !socketRef.current.connected) {
        socketRef.current.connect();
      }
    };

    const handleOffline = () => {
      console.log("📴 Network offline");
    };

    window.addEventListener("focus", handleFocus);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleJoinAuction]);

  const isReady = useMemo(() => !bidLoader && !unitLoader && !nextUnitLoader, [bidLoader, unitLoader, nextUnitLoader]);

  return (
    <>
      {/* Latency koneksi saat terhubung */}
      {socketStatus === "connected" && <ConnectionLatency latencyMs={latencyMs} />}

      {/* Socket Status Indicator */}
      {socketStatus !== "connected" && (
        <div
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            background: getSocketStatusColor(),
            color: textWhite,
            padding: "8px 16px",
            borderRadius: "4px",
            fontSize: "14px",
            zIndex: 9999,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          {getSocketStatusText()}
        </div>
      )}

      {/* Max Reconnect Reached Modal */}
      {maxReconnectReached && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: textWhite,
              padding: "30px",
              borderRadius: "8px",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <Warning color={danger} width="48" height="48" />
            </div>
            <h3 style={{ color: textDark, marginBottom: "15px" }}>Koneksi Terputus</h3>
            <p
              style={{
                color: textDark,
                marginBottom: "25px",
                lineHeight: "1.5",
              }}
            >
              Koneksi ke server telah terputus setelah {MAX_RECONNECT_ATTEMPTS} kali percobaan. Silakan refresh halaman
              untuk mencoba kembali.
            </p>
            <Button
              variant="primary"
              onClick={handleRefreshPage}
              style={{
                padding: "10px 30px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Refresh Halaman
            </Button>
          </div>
        </div>
      )}

      {liveAuction === "STARTED" ? (
        <>
          {isReady ? (
            <>
              <div className="page h-100 pb-3">
                <Container>
                  <Row>
                    <Col lg={5}>
                      <div className="box-border mt-15">
                        <div className="unit-slider w-100">
                          <CarouselLayout className="dots-left" dots={true} adaptiveHeight={true}>
                            {images?.length > 0 ? (
                              images.slice(0, 5).map((image, i) => (
                                <div key={"img" + i}>
                                  <img
                                    className="with-background detail-unit-slider"
                                    src={image.image_url || image.image}
                                    alt={`Unit preview ${i + 1}`}
                                    style={{
                                      height: "auto",
                                      width: "100%",
                                      display: "block",
                                    }}
                                    onError={(e) => {
                                      e.target.src = defaultImage;
                                    }}
                                  />
                                </div>
                              ))
                            ) : (
                              <div style={{ height: "222px" }}>
                                <div
                                  className="with-background detail-unit-slider"
                                  style={{
                                    background: defaultImage ? `url(${defaultImage})` : "",
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "contain",
                                    minHeight: 200,
                                  }}
                                ></div>
                              </div>
                            )}
                          </CarouselLayout>

                          {data?.unit_inspection_grade && (
                            <div className="grade-desktop d-none d-lg-block">
                              <p className="nomor-lot">
                                Grade
                                <span>{data?.unit_inspection_grade}</span>
                              </p>
                            </div>
                          )}
                          {/* mobile view */}
                          <div className="d-block d-lg-none position-absolute top-0 end-0">
                            <div className="badge-lot">
                              <span className="nomor-lot me-2">
                                Lot{" "}
                                {auction?.auction_lane_name && data?.lot_number
                                  ? auction?.auction_lane_name + data?.lot_number
                                  : "-"}
                              </span>
                              <span className="nomor-lot">Grade {data?.unit_inspection?.grade || "-"}</span>

                              {data?.number_of_nipl > 1 && (
                                <span className="nomor-lot nipl">
                                  <span className="icon-nipl">
                                    <SpecialNIPL />
                                  </span>
                                  Special NIPL
                                </span>
                              )}
                            </div>
                          </div>

                          {/* desktop view */}
                          {data?.unit_inspection?.grade && (
                            <div className="grade-unit-auction d-none d-lg-absolute">
                              Grade
                              <br />
                              <span className="grade-auction">{data?.unit_inspection?.grade}</span>
                            </div>
                          )}
                        </div>
                        <div className="d-none d-lg-block">
                          <h2 className="unit-name-auction">{data?.unit_name || ""}</h2>
                          <span className="unit-title">Highlight</span>
                          <div className="unit-highlight mt-2">
                            {data?.tags?.length > 0
                              ? data?.tags.map((row, i) => <span key={"tag" + i}>{row.name}</span>)
                              : "-"}
                          </div>

                          <span className="unit-title">Detail Kendaraan</span>
                          <UnitInformation informations={data?.stock_informations} documents={data?.stock_documents} />
                        </div>
                      </div>
                    </Col>
                    <Col lg={7}>
                      <div className="mt-15">
                        <div className="d-none d-lg-block">
                          <div className="badge-lot">
                            <span className="nomor-lot">
                              Lot{" "}
                              {auction?.auction_lane_name && data?.lot_number
                                ? auction?.auction_lane_name + data?.lot_number
                                : "-"}
                            </span>
                            {data?.number_of_nipl > 1 && (
                              <span className="nomor-lot nipl">
                                <span className="icon-nipl">
                                  <SpecialNIPL />
                                </span>
                                Special NIPL
                              </span>
                            )}
                            <span className="nomor-lot close-bid">Close Bid</span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="unit-title">Harga Dasar</span>
                          {/* <span className="d-inline d-lg-none unit-title">Bidder</span> */}
                        </div>
                        <div className="group">
                          <span
                            className="unit-price"
                            style={{
                              flex: "1",
                              textDecoration:
                                data?.is_cancel_auction && data?.is_cancel_auction !== "0" ? "line-through" : "none",
                              textDecorationColor: "red",
                              textDecorationThickness: "3px",
                            }}
                          >
                            Rp {data?.base_price !== undefined ? data?.base_price?.toLocaleString() : "0"}
                          </span>
                          {/* <span
                            className="count-customer"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "6px 12px",
                              backgroundColor: "#f0f4f8",
                              borderRadius: "20px",
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#374151",
                              border: "1px solid #e5e7eb",
                            }}
                          >
                            <UserIcon style={{ width: "16px", height: "16px" }} />
                            <span>{userCount || 0} Orang</span>
                          </span> */}
                        </div>

                        <div className="bidder-list" style={{ marginTop: "20px" }}>
                          <div className="header d-flex flex-column-reverse flex-lg-row justify-content-between align-items-start align-items-lg-center gap-2">
                            <span className="title m-0" style={{ textAlign: "left" }}>
                              Harga Penawaran Anda Saat Ini
                            </span>
                            <div className="d-flex p-0 p-lg-3 timer-container">
                              <span className="timer w-100">
                                <TimerIcon />
                                {secondsToTime(counter)}
                              </span>
                            </div>
                          </div>
                          {FirstBid && (
                            <>
                              {/* ini untuk desktop view */}
                              <div className="d-none d-lg-block px-4 pb-4">
                                <div className="highest-bid border" style={{ borderRadius: "0.5rem" }}>
                                  <span className="bid-value">
                                    Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : "-"}
                                  </span>
                                  <span className="bidder">
                                    {moment(highestBid?.date).format("DD MMM YYYY (HH:mm)")}
                                    {/* {highestBid?.type === 'Timebid Bidder' && highestBid?.buyer?.user_id === thisUser.id
                                  ? 'Saya'
                                  : highestBid?.type || '-'} */}
                                  </span>
                                </div>
                              </div>
                              {/* ini untuk mobile view */}
                              <div className="d-block d-lg-none px-4 pb-4">
                                <div className="highest-bid d-flex border" style={{ borderRadius: "0.5rem" }}>
                                  <span className="bid-value" style={{ fontSize: "20px" }}>
                                    Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : "-"}
                                  </span>
                                  <span className="bidder" style={{ fontSize: "16px" }}>
                                    {moment(highestBid?.date).format("DD MMM YYYY (HH:mm)")}
                                    {/* {highestBid?.type === 'Timebid Bidder' && highestBid?.buyer?.user_id === thisUser.id
                                  ? 'Saya'
                                  : highestBid?.type || '-'} */}
                                  </span>
                                </div>
                              </div>
                            </>
                          )}
                          <div className="bidder-data ">
                            {biddingList?.length > 0
                              ? biddingList
                                  ?.filter((bid) => bid?.offer_price !== highestBid?.offer_price)
                                  ?.map((bid, index) => (
                                    <div
                                      className={`bidder-item ${
                                        bid?.type === "Timebid Bidder" &&
                                        bid?.buyer?.user_id === thisUser.id &&
                                        "active"
                                      }`}
                                      key={`bid-${index}`}
                                    >
                                      <span className="bid-value">Rp {bid?.offer_price?.toLocaleString()}</span>
                                      <span className="bidder">
                                        {moment(bid?.date).format("DD MMM YYYY (HH:mm)")}
                                        {/* {bid?.type === 'Timebid Bidder' && bid?.buyer?.user_id === thisUser.id ? 'Saya' : bid?.type || '-'} */}
                                      </span>
                                    </div>
                                  ))
                              : !FirstBid && (
                                  <div
                                    className="close-bid-no-bidding text-center d-flex justify-content-center flex-column"
                                    style={{ height: "250px", color: "#1E1E1F", gap: "10px" }}
                                  >
                                    <span className="fw-semibold" style={{ fontSize: "20px" }}>
                                      Anda belum melakukan penawaran apapun
                                    </span>
                                    <span className="mx-auto font-sm">
                                      Silahkan masukkan nilai penawaran anda untuk memulai penawaran
                                    </span>
                                  </div>
                                )}
                          </div>
                        </div>

                        <div
                          className="d-none d-xl-block box-border form-bid"
                          style={{ marginTop: "20px", overflow: "hidden" }}
                        >
                          <BidControl
                            SpecialNIPLToggle={SpecialNIPLToggle}
                            auction={auction}
                            disableBid={disableBid}
                            bidHandler={bidHandler}
                            counter={counter}
                            offer={offer}
                            changeOffer={changeOffer}
                            handleDecreaseBid={handleDecreaseBid}
                            handleIncreaseBid={handleIncreaseBid}
                            error={error}
                            thisUser={thisUser}
                            blockBid={blockBid}
                            isProcess={isProcess}
                            isCancelProcess={isCancelProcess}
                            data={data}
                            colorCancel={colorCancel}
                            handleClickCancelBid={handleClickCancelBid}
                            color={color}
                            postBid={postBid}
                            disabledSubstract={
                              disableBid === "off" || offer <= data?.base_price || unitLoader || bidLoader
                            }
                            disabledPlus={disableBid === "off" || unitLoader || bidLoader}
                            disabledCancel={
                              !FirstBid ||
                              disableBid === "off" ||
                              blockBid === "on" ||
                              isProcess === "on" ||
                              isCancelProcess === "on" ||
                              highestBid?.offer_price === 0 ||
                              unitLoader ||
                              bidLoader
                            }
                            disabledTawar={
                              disableBid === "off" ||
                              blockBid === "on" ||
                              isProcess === "on" ||
                              isCancelProcess === "on" ||
                              unitLoader ||
                              bidLoader
                            }
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>

                {/* ini hanya tampil di mobile */}
                <Container className="d-block d-lg-none">
                  <div className="box-lelang p-3" style={{ margin: "20px 0" }}>
                    <span className="unit-title mt-0">Highlight</span>
                    <div className="unit-highlight">
                      {data?.tags?.length > 0
                        ? data?.tags.map((row, i) => <span key={"tag" + i}>{row.name}</span>)
                        : "-"}
                    </div>

                    <span className="unit-title">Detail Kendaraan</span>
                    <div className="bidder-data">
                      <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
                        {data?.stock_informations?.length > 0
                          ? data?.stock_informations
                              ?.filter((el) => el.value !== "")
                              .map(({ label, value }, idx) => (
                                <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                                  <span className="title">{label}</span>
                                  <span className="value">
                                    {isDate(value)
                                      ? moment(value).format("DD MMM YYYY")
                                      : value !== "null" && value
                                        ? value
                                        : "-"}
                                  </span>
                                </div>
                              ))
                          : ""}
                        {data?.stock_documents?.length > 0
                          ? data?.stock_documents
                              ?.filter((el) => el.value !== "")
                              .map(({ label, value }, idx) => (
                                <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                                  <span className="title">{label}</span>
                                  <span className="value">{value || "-"}</span>
                                </div>
                              ))
                          : ""}
                      </div>
                    </div>
                  </div>
                </Container>
                <Container>
                  <Row>
                    <Col lg="12">
                      <div
                        className="box-lelang d-none d-lg-block"
                        style={
                          data?.current_stock_unit?.unit_type?.banner_url
                            ? {
                                marginTop: "20px",
                                background: `url(${data?.current_stock_unit?.unit_type?.banner_url})`,
                              }
                            : {
                                marginTop: "20px",
                                backgroundImage: `url(${imageCar})`,
                              }
                        }
                      >
                        <div className="group">
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <span className="lelang-title">{auction?.name || "-"}</span>
                            <div className="lelang-date" style={{ color: "#1E1E1F" }}>
                              {formatSimpleDateRange(auction?.date_start, auction?.date_finish)}
                            </div>
                          </div>
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <div className="lelang-time">
                              <Time />{" "}
                              <span>
                                {auction?.date_start && auction?.time_start
                                  ? format(new Date(`${auction.date_start} ${auction.time_start}`), "HH:mm")
                                  : "-"}{" "}
                                -{" "}
                                {auction?.date_start && auction?.time_finish
                                  ? format(new Date(`${auction?.date_start} ${auction?.time_finish}`), "HH:mm")
                                  : "-"}{" "}
                                WIB
                              </span>
                            </div>
                            <div className="lelang-location">
                              <Location /> <span>{auction?.location_name || "-"}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="box-lelang d-flex d-lg-none" style={{ marginTop: "20px" }}>
                        <div className="d-flex flex-column flex-lg-column">
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <span className="lelang-title">{auction?.name || "-"}</span>
                            <div className="lelang-date" style={{ color: "#1E1E1F" }}>
                              {auction?.date_start && auction?.time_start
                                ? format(new Date(`${auction.date_start} ${auction.time_start}`), "dd MMM yyyy")
                                : "-"}
                            </div>
                          </div>
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <div className="lelang-time">
                              <Time />{" "}
                              <span>
                                {auction?.date_start && auction?.time_start
                                  ? format(new Date(`${auction.date_start} ${auction.time_start}`), "HH:mm")
                                  : "-"}{" "}
                                -{" "}
                                {auction?.date_start && auction?.time_finish
                                  ? format(new Date(`${auction?.date_start} ${auction?.time_finish}`), "HH:mm")
                                  : "-"}{" "}
                                WIB
                              </span>
                            </div>
                            <div className="lelang-location">
                              <Location /> <span>{auction?.location_name || "-"}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container>
                  <div className="produk-terkait w-100">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h3>Lot Lainnya</h3>
                      <div className="d-flex" style={{ gap: "8px" }}>
                        {allNextLots?.length > 4 && (
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="d-none d-md-block"
                            onClick={() => {
                              if (showAllLots) {
                                setNextLots(allNextLots.slice(0, 4));
                                setShowAllLots(false);
                              } else {
                                setNextLots(allNextLots);
                                setShowAllLots(true);
                              }
                            }}
                          >
                            {showAllLots ? "Tampilkan Lebih Sedikit" : `Lihat Lainnya (${allNextLots.length - 4}+)`}
                          </Button>
                        )}
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="d-md-none"
                          onClick={() => setShowSidebar(true)}
                        >
                          Lihat Semua
                        </Button>
                      </div>
                    </div>
                    <CarouselMultipleLayout slideToShow={4} totalItem={nextLots?.length || 0}>
                      {nextLots?.length > 0 ? (
                        nextLots.map((item, idx) => (
                          <LazyLotCard
                            key={`lot-${item?.id || idx}`}
                            item={item}
                            auction={auction}
                            id={id}
                            push={push}
                          />
                        ))
                      ) : (
                        <div className="col-md-12 text-center py-4">Tidak ada Lot selanjutnya</div>
                      )}
                    </CarouselMultipleLayout>
                  </div>
                </Container>

                {/* Sidebar Mobile untuk Lot Lainnya */}
                <Offcanvas
                  show={showSidebar}
                  onHide={() => setShowSidebar(false)}
                  placement="end"
                  className="d-lg-none"
                  style={{ width: "85%" }}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Lot Lainnya</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <div className="d-flex flex-column" style={{ gap: "0.5rem" }}>
                      {allNextLots?.length > 0 ? (
                        allNextLots.map((item, idx) => {
                          const lotNumber = item?.lot_number || "-";
                          const unitName = item?.unit_name || "Unit Tidak Diketahui";
                          return (
                            <div
                              key={"sidebar-lot" + idx}
                              style={{
                                cursor: "pointer",
                                padding: "12px 16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                border: "1px solid #dee2e6",
                                transition: "all 0.2s ease",
                              }}
                              onClick={() => {
                                setShowSidebar(false);
                                push(`/close-bid-auction/${id}/${item?.id}`);
                                window.location.reload();
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#e9ecef";
                                e.currentTarget.style.borderColor = "#adb5bd";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                e.currentTarget.style.borderColor = "#dee2e6";
                              }}
                            >
                              <div style={{ fontSize: "14px", fontWeight: "600", color: "#212529" }}>
                                LOT {lotNumber} - {unitName}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p className="text-center text-muted">Tidak ada Lot selanjutnya</p>
                      )}
                    </div>
                  </Offcanvas.Body>
                </Offcanvas>

                {/* tampil saat mobile */}
                <div
                  className="d-block d-xl-none position-fixed w-100 bottom-0 box-border form-bid"
                  style={{ marginTop: "20px", overflow: "hidden", zIndex: 2 }}
                >
                  <BidControl
                    SpecialNIPLToggle={SpecialNIPLToggle}
                    auction={auction}
                    disableBid={disableBid}
                    bidHandler={bidHandler}
                    counter={counter}
                    offer={offer}
                    thisUser={thisUser}
                    changeOffer={changeOffer}
                    handleDecreaseBid={handleDecreaseBid}
                    handleIncreaseBid={handleIncreaseBid}
                    error={error}
                    blockBid={blockBid}
                    isProcess={isProcess}
                    isCancelProcess={isCancelProcess}
                    data={data}
                    colorCancel={colorCancel}
                    handleClickCancelBid={handleClickCancelBid}
                    color={color}
                    postBid={postBid}
                    disabledSubstract={disableBid === "off" || offer <= data?.base_price || unitLoader || bidLoader}
                    disabledPlus={disableBid === "off" || unitLoader || bidLoader}
                    disabledCancel={
                      !FirstBid ||
                      disableBid === "off" ||
                      blockBid === "on" ||
                      isProcess === "on" ||
                      isCancelProcess === "on" ||
                      highestBid?.offer_price === 0 ||
                      unitLoader ||
                      bidLoader
                    }
                    disabledTawar={
                      disableBid === "off" ||
                      blockBid === "on" ||
                      isProcess === "on" ||
                      isCancelProcess === "on" ||
                      unitLoader ||
                      bidLoader
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            <OnlineAuctionSkeleton />
          )}
        </>
      ) : null}
      {liveAuction === "COMING" || liveAuction === "CLOSED" ? <ArtworkPending status={liveAuction} /> : ""}
      {liveAuction === "NOT_FOUND" ? <PageNotFound></PageNotFound> : ""}
      {modalCancel && (
        <KonfirmasiBatalBid
          onCancel={() => setModalCancel(false)}
          onSubmit={cancelBid}
          isCancelProcess={isCancelProcess === "on" ? true : false}
        />
      )}
      {isOpen ? <ResultLelang status={result} dataAuction={dataModal?.data_unit} /> : ""}
      {isSelectingWinner ? <ResultLelang status="LOADING" dataAuction={dataModal?.data_unit} /> : ""}
    </>
  );
}

const BidControl = ({
  SpecialNIPLToggle,
  auction,
  disableBid,
  bidHandler,
  counter,
  offer,
  changeOffer,
  handleDecreaseBid,
  handleIncreaseBid,
  error,
  thisUser,
  blockBid,
  isProcess,
  isCancelProcess,
  data,
  colorCancel,
  handleClickCancelBid,
  color,
  postBid,
  disabledSubstract,
  disabledPlus,
  disabledCancel,
  disabledTawar,
}) => {
  const validatingClickButton = (callback) => {
    if (data?.id) {
      callback();
    } else {
      toast.error("Data masih dalam proses pemuatan, mohon tunggu beberapa saat dan coba lagi");
    }
  };
  return (
    <>
      {SpecialNIPLToggle &&
        SpecialNIPLToggle.is_special_nipl === "true" &&
        SpecialNIPLToggle.remaining_nipls < SpecialNIPLToggle.number_of_nipl && (
          <div
            className="alert-nipl mobile-alert-nipl"
            style={{
              top: "15px",
              marginTop: "-35px",
            }}
          >
            <Warning color="#FF4D4D" /> Jumlah NIPL Anda tidak cukup untuk melakukan penawaran
          </div>
        )}
      <div className="d-flex tw-justify-between m-2">
        <span className="title-header">Tawar</span>{" "}
        {auction?.is_non_deposit !== 1 && (
          <div className="coupon-header d-flex">
            <Coupon />
            <p className="m-0">
              NIPL anda: <span>{SpecialNIPLToggle?.remaining_nipls || 0}</span>
            </p>
          </div>
        )}
      </div>
      <div className="d-flex w-100 justify-content-end">
        {SpecialNIPLToggle.is_special_nipl === "true" && (
          <div className="coupon-footer d-flex">
            <Coupon />
            <p
              className="m-0"
              style={{
                borderRight: "none",
              }}
            >
              <span>{SpecialNIPLToggle.number_of_nipl} NIPL</span> untuk menawar
            </p>
          </div>
        )}
      </div>
      <div className="group d-flex align-items-center">
        <div
          className="d-flex"
          style={{
            flexWrap: "wrap",
            alignItems: "center",
            textAlign: "right",
            justifyContent: "space-between",
            width: "fit-content",
          }}
        >
          <div className="d-flex d-xl-none flex-column-reverse gap-1 align-items-center">
            {data?.is_cancel_auction !== "1" && (
              <>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  checked={disableBid === "on" ? true : false}
                  onChange={() => validatingClickButton(bidHandler)}
                  disabled={counter <= 0 || counter === null}
                />
                <div className={`d-flex align-items-center`}>
                  <span
                    className="font-sm "
                    style={{
                      color: disableBid === "on" ? "#2AB95E" : "#ff0000",
                    }}
                  >
                    {disableBid === "on" ? "Aktif" : "Matikan"}
                  </span>
                </div>
              </>
            )}
          </div>{" "}
        </div>
        <div style={{ flex: "1", gap: "4px" }} className="d-flex flex">
          <InputGroup>
            <InputGroup.Text id="basic-addon1">Rp</InputGroup.Text>
            <CurrencyInput
              id="hargaTawar"
              name="offer"
              className="form-control"
              placeholder="Masukan penawaran"
              disabled={disableBid === "off" || blockBid === "on"}
              value={offer}
              prefix="Rp "
              groupSeparator=","
              decimalSeparator="."
              readOnly
              allowDecimals={false}
              onValueChange={(value, name) => changeOffer(value)}
            />
          </InputGroup>
          <ButtonGroup
            size="sm"
            aria-label="Adjuster Offer"
            style={{ border: "1px solid #BEBFC2", borderRadius: "8px" }}
          >
            <Button
              variant="light"
              disabled={disabledSubstract}
              style={{ borderTopLeftRadius: "7px", borderBottomLeftRadius: "7px" }}
              onClick={() => validatingClickButton(handleDecreaseBid)}
            >
              <SubstractIcon />
            </Button>
            <Button
              variant="light"
              disabled={disabledPlus}
              style={{ borderLeft: "1px solid #BEBFC2", borderTopRightRadius: "7px", borderBottomRightRadius: "7px" }}
              onClick={() => validatingClickButton(handleIncreaseBid)}
            >
              <PlusIcon />
            </Button>
          </ButtonGroup>
          <small className="text-primary">{error}</small>
        </div>
      </div>

      {/* tampilan desktop*/}
      <div className="group d-xl-flex d-none flex-center tes" style={{ marginTop: "10px" }}>
        <div
          className="d-flex flex-column"
          style={{
            flexWrap: "wrap",
            // alignItems: 'center',
            textAlign: "left",
            justifyContent: "space-between",
            maxWidth: "530px",
            width: "100%",
          }}
        >
          <div className="d-flex align-items-center px-4">
            {/* {data?.is_cancel_auction && data?.is_cancel_auction !== "1" && ( */}
            <>
              <Form.Check
                className="ms-1 me-2"
                type="switch"
                id="custom-switch"
                checked={disableBid === "on" ? true : false}
                onChange={() => validatingClickButton(bidHandler)}
                disabled={counter <= 0 || counter === null}
              />
              <div className={`d-flex align-items-center ml-2`}>
                {disableBid === "on" ? (
                  <>
                    <LockOff active={disableBid} />
                    <span
                      className="font-sm ml-1 "
                      style={{
                        color: disableBid === "on" ? "#2AB95E" : "",
                      }}
                    >
                      Aktif
                    </span>
                  </>
                ) : (
                  <>
                    <LockOn active={disableBid} />
                    <span
                      className="font-sm ml-1 "
                      style={{
                        color: disableBid === "off" ? "#ff0000" : "",
                      }}
                    >
                      Nonaktif
                    </span>
                  </>
                )}
              </div>
            </>
            {/* )} */}
          </div>
          {SpecialNIPLToggle.is_special_nipl === "true" && (
            <div className="coupon-footer d-flex" style={{ width: "170px", minWidth: "unset" }}>
              <Coupon />
              <p className="m-0" style={{ border: 0 }}>
                <span>{SpecialNIPLToggle.number_of_nipl} NIPL</span> untuk menawar
              </p>
            </div>
          )}
        </div>
        <div className="d-flex" style={{ gap: "10px" }}>
          <Button
            className={`${disableBid === "off" ? "cancel-bid-off w-full" : "cancel-bid-on"} text-nowrap w-100`}
            disabled={disabledCancel}
            onClick={() => validatingClickButton(handleClickCancelBid)}
            variant={colorCancel}
          >
            {isCancelProcess === "on" ? <Spinner animation="border" /> : "Cancel Penawaran"}
          </Button>
          <Button
            className={`${disableBid === "off" ? "bid-off" : "bid-on"} w-100`}
            disabled={disabledTawar}
            onClick={() => validatingClickButton(postBid)}
            variant={color}
          >
            {isProcess === "on" ? <Spinner animation="border" /> : "Tawar"}
          </Button>
        </div>
      </div>

      {/* tampilan mobile */}
      <div className="group d-xl-none align-items-center" style={{ marginTop: "10px" }}>
        <Button
          className={`${disableBid === "off" ? "cancel-bid-off w-full" : "cancel-bid-on"} text-nowrap w-100`}
          disabled={disabledCancel}
          onClick={() => validatingClickButton(handleClickCancelBid)}
          variant={colorCancel}
        >
          {isCancelProcess === "on" ? <Spinner animation="border" /> : "Cancel Penawaran"}
        </Button>
        <Button
          className={`${disableBid === "off" ? "bid-off" : "bid-on"} w-100`}
          disabled={disabledTawar}
          onClick={() => validatingClickButton(postBid)}
          variant={color}
        >
          {isProcess === "on" ? <Spinner animation="border" /> : "Tawar"}
        </Button>
      </div>
    </>
  );
};
